export default {
  "seo.title": "Về chúng tôi | Bonvi",
  "seo.description": "Khám phá đội ngũ, kinh nghiệm và các lĩnh vực sáng tạo làm nên Bonvi.",
  "number.title": "Những con số của chúng tôi",
  "number.copy": "Đội ngũ của chúng tôi làm việc trên nhiều lĩnh vực, giúp mỗi dự án hội tụ đúng tổ hợp kỹ năng cần thiết.",
  "number.years": "Năm kinh nghiệm",
  "number.projects": "Dự án đã hoàn thành",
  "number.markets": "Thị trường đã tiếp cận",
  "strategy.title": "Chiến lược của chúng tôi",
  "strategy.copy": "Bonvi mở rộng năng lực sáng tạo bằng cách kết hợp vận hành ứng dụng AI với nguồn nhân lực sáng tạo đa dạng tại Đông Nam Á, mang đến cho các thương hiệu giàu tham vọng tốc độ cao hơn, chiều sâu văn hóa và hiệu quả tốt hơn mà không cần gánh chi phí xây dựng một đội ngũ nội bộ quy mô lớn.",
  "strategy.ariaLabel": "Các nguyên tắc chiến lược của chúng tôi",
  "strategy.core.creative": "Sáng tạo",
  "strategy.core.growthAt": "tăng trưởng",
  "strategy.core.scale": "ở quy mô lớn",
  "strategy.ai": "Động cơ sáng tạo ứng dụng AI",
  "strategy.sea": "Mạng lưới tài năng Đông Nam Á",
  "strategy.global": "Bản địa hóa toàn cầu",
  "strategy.embedded": "Đội ngũ tích hợp",
  "strategy.human": "Định hướng sáng tạo từ con người",
  "strategy.performance": "Sáng tạo hướng đến hiệu quả",
  "creative.title": "Năng lực sáng tạo của chúng tôi",
  "creative.copy1": "Đội ngũ của chúng tôi làm việc trên nhiều lĩnh vực, giúp mỗi dự án hội tụ đúng tổ hợp kỹ năng cần thiết.",
  "creative.copy2": "Chúng tôi không tin vào một công thức sáng tạo áp dụng cho tất cả. Mỗi dự án được định hình bởi khán giả, nền tảng và mục tiêu riêng, kết hợp tư duy chiến lược với thử nghiệm thị giác để tạo nên những sản phẩm khác biệt, phù hợp và có sức ảnh hưởng.",
  "creative.ariaLabel": "Các nguyên tắc sáng tạo của chúng tôi",
  "creative.idea": "Ý tưởng là điểm khởi đầu",
  "creative.medium": "Thiết kế phù hợp với phương tiện",
  "creative.motion": "Chuyển động trong DNA của chúng tôi",
  "creative.performance": "Sáng tạo tạo nên hiệu quả",
} as const;
